import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_ctx.drawer)
    ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
        key: 0,
        modelValue: _ctx.drawer,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.drawer) = $event)),
        location: "right",
        temporary: ""
      }, {
        prepend: _withCtx(() => [
          _createVNode(_component_v_list_item, { "two-line": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currentUser.firstname) + " " + _toDisplayString(_ctx.currentUser.lastname), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item_subtitle, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currentUser.company.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item_subtitle, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currentUser.email ? _ctx.currentUser.email.split("#")[0] : "XXX"), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        append: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-end px-2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.bobbee_hrz,
                    height: "25px"
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    block: "",
                    elevation: "0",
                    class: "rounded-lg gradient error mt-2",
                    large: "",
                    onClick: _ctx.logout,
                    "data-cy": "index-logout"
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Se déconnecter")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_divider),
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, { ripple: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, {
                    onClick: _withModifiers(_ctx.onPasswordChangeClick, ["stop"]),
                    class: "text-decoration-underline",
                    style: {"cursor":"pointer"}
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("Changer de mot de passe")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}